// extracted by mini-css-extract-plugin
module.exports = {"contactItem":"index_contactItem__Iix_D","right":"index_right__l6mdj"};